
<template>
  <div v-if="loggedIn" class="inactivity-timer">
      <span class="timer-label">Session timeout:</span>
      <span
          class="timer-value"
          :class="{ 'timer-warning': remainingSeconds <= 60 }"
      >
          {{ formattedTime }}
      </span>
  </div>
</template>

<script>
import { serverBus } from '../eventBus';

export default {
  name: 'InactivityTimer',

  data() {
      return {
          remainingSeconds: 600,
          loggedIn: !!localStorage.getItem('token')
      };
  },

  computed: {
      formattedTime() {
          const minutes = Math.floor(this.remainingSeconds / 60);
          const seconds = this.remainingSeconds % 60;

          return (
              String(minutes).padStart(2, '0') +
              ':' +
              String(seconds).padStart(2, '0')
          );
      }
  },

  mounted() {
      serverBus.$on('inactivity-timer', this.updateTimer);
      serverBus.$on('inactivity-logout', this.handleLogout);
  },

  beforeDestroy() {
      serverBus.$off('inactivity-timer', this.updateTimer);
      serverBus.$off('inactivity-logout', this.handleLogout);
  },

  methods: {
      updateTimer(seconds) {
          this.remainingSeconds = seconds;
          this.loggedIn = !!localStorage.getItem('token');
      },

      handleLogout() {
          this.loggedIn = false;
      }
  }
};
</script>

<style scoped>
.inactivity-timer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
}

.timer-label {
  color: #555;
}

.timer-value {
  color: #198754;
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.timer-warning {
  color: #dc3545;
}
</style>
